import { render, staticRenderFns } from "./UploadDocs.vue?vue&type=template&id=8b9f533e&scoped=true&"
import script from "./UploadDocs.vue?vue&type=script&lang=js&"
export * from "./UploadDocs.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocs.vue?vue&type=style&index=0&id=8b9f533e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9f533e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b9f533e')) {
      api.createRecord('8b9f533e', component.options)
    } else {
      api.reload('8b9f533e', component.options)
    }
    module.hot.accept("./UploadDocs.vue?vue&type=template&id=8b9f533e&scoped=true&", function () {
      api.rerender('8b9f533e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/UploadDocs.vue"
export default component.exports